import styled from "styled-components";

const Container = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background: ${ props => props.color };
`;

export { Container };